import React, { Component } from "react";
import { Card, CardBody, CardFooter, Button } from "reactstrap";

class SliderPublishers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idSliderPublisher: this.props.sliderpublisher?.id || null,
      name: this.props.sliderpublisher?.name || "",
      hyperlink: this.props.sliderpublisher?.hyperlink || "",
      slidebar: this.props.sliderpublisher?.slidebar || "",
      savable: true,
    };
  }

  render() {
    const { idSliderPublisher, name, hyperlink, slidebar } = this.state;

    return (
      <Card className="mb-3">
        {/* Gambar slider */}
        {slidebar && (
          <img
            src={slidebar}
            alt={name}
            className="card-img-top"
            style={{ maxHeight: "200px", objectFit: "cover" }}
          />
        )}

        <CardBody>
          <h5 className="card-title">{name}</h5>
          <p className="card-text">
            <b>Hyperlink:</b> {hyperlink}
          </p>
        </CardBody>

        <CardFooter className="d-flex justify-content-between">
          <Button
            color="warning"
            size="sm"
            onClick={() => this.props.onEdit(this.state.idSliderPublisher)}
          >
            <i className="nc-icon nc-ruler-pencil"></i> Edit
          </Button>
          <Button
            color="danger"
            size="sm"
            onClick={() => this.props.onDelete(this.state.idSliderPublisher)}
          >
            <i className="nc-icon nc-simple-remove"></i> Delete
          </Button>
        </CardFooter>
      </Card>
    );
  }
}

export default SliderPublishers;
